<template>
  <router-view />
</template>
<script>
import {defineComponent, onMounted, ref, watch} from 'vue'
import {useRoute} from 'vue-router'
import {useMeta} from 'quasar'
import {worker} from './mocks/browser'
import pkg from '../package.json'

export default defineComponent({
  name: 'App',
  setup() {
    /**
     * データ定義
     */
    const route = useRoute()
    const baseTitle = pkg.productName
    const title = ref('')

    /**
     * watcher
     */
    watch(
      () => route.meta.title,
      (newTitle) => {
        title.value = newTitle ?? ''
      }
    )

    /**
     * meta情報設定
     */
    useMeta(() => {
      return {
        title: title.value,
        titleTemplate: (title) => {
          return title !== '' ? `${title} | ${baseTitle}` : baseTitle
        },
      }
    })

    /**
     * onMounted
     */
    onMounted(() => {
      if (process.env.MOCK_MODE) {
        worker.start()
      }
    })
  }
})
</script>
